import {KeyLabel} from './key-label.model';
export enum PublisherAdUnitRequestStatus {
  REQUESTED = 'REQUESTED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
}

export const PublisherAdUnitRequestStatusLabels = {
  REQUESTED: 'Requested',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled'
};

export const PublisherAdUnitRequestStatusKL = () =>
  (Object.keys(PublisherAdUnitRequestStatusLabels).map(
      key => new KeyLabel<PublisherAdUnitRequestStatus>(PublisherAdUnitRequestStatus[key], PublisherAdUnitRequestStatusLabels[key]))
  );
